export default __webpack_public_path__ + "static/media/Participant-background-1.d4a723af.jpg";